module.exports = __webpack_public_path__ + "img/pin_island.c56da841.png";